import { render, staticRenderFns } from "./KardexReceive.vue?vue&type=template&id=0484a5cc&scoped=true&"
import script from "./KardexReceive.vue?vue&type=script&lang=js&"
export * from "./KardexReceive.vue?vue&type=script&lang=js&"
import style0 from "./KardexReceive.vue?vue&type=style&index=0&id=0484a5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484a5cc",
  null
  
)

export default component.exports